export enum QuestionType {
  DEMOGRAPHIC = 'demographic',
  QUANTITATIVE = 'quantitative',
  QUALITATIVE = 'qualitative',
  INTERPRETIVE = 'interpretive',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}

export enum QuestionCategory {
  IDENTITY = 'identity',
  EXPERIENCE_TYPE = 'experience_type',
  EMOTIONAL_SUPPORT = 'emotional_support',
  UNDERSTANDING = 'understanding',
  EFFECTIVENESS = 'effectiveness',
  EMOTIONAL_SHIFT = 'emotional_shift',
  LIKELIHOOD_TO_USE = 'likelihood_to_use',
  DESCRIPTION = 'description',
  MEANINGFUL_ASPECTS = 'meaningful_aspects',
  MISSING_ASPECTS = 'missing_aspects',
  EXPLANATION = 'explanation',
  TECHNOLOGY_SHIFT = 'technology_shift',
}

export interface Question {
  _id?: string;
  text: string;
  type: QuestionType;
  category: QuestionCategory;
  options?: string[];
  minScale?: number;
  maxScale?: number;
  placeholder?: string;
  helpText?: string;
}

export interface Survey {
  _id: string;
  title: string;
  description?: string;
  questions: Question[];
  organizationId?: string;
  createdBy: {
    _id: string;
    username: string;
    email: string;
  };
  isActive: boolean;
  isPublished: boolean;
  publishedAt?: string;
  responseCount: number;
  viewCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface SurveyResponse {
  _id: string;
  surveyId: string;
  userId: string;
  organizationId?: string;
  conversationId?: string;
  answers: Answer[];
  sessionId?: string;
  userAgent?: string;
  ipAddress?: string;
  isCompleted: boolean;
  completedAt?: string;
  timeSpent?: number;
  tags?: string[];
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface Answer {
  questionId: string;
  type: ResponseType;
  textAnswer?: string;
  scaleAnswer?: number;
  choiceAnswers?: string[];
}

export enum ResponseType {
  TEXT = 'text',
  SCALE = 'scale',
  MULTIPLE_CHOICE = 'multiple_choice',
  SINGLE_CHOICE = 'single_choice',
}

export interface CreateSurveyResponseDto {
  surveyId: string;
  userId: string;
  organizationId?: string;
  conversationId?: string;
  answers: Answer[];
  sessionId?: string;
  userAgent?: string;
  ipAddress?: string;
}

export interface SurveyFormData {
  [questionId: string]: {
    type?: ResponseType;
    textAnswer?: string;
    scaleAnswer?: number;
    choiceAnswers?: string[];
  };
}

export interface SurveyProgress {
  currentQuestion: number;
  totalQuestions: number;
  completedQuestions: number;
  isCompleted: boolean;
}

export interface SurveyState {
  surveys: Survey[];
  currentSurvey: Survey | null;
  surveyResponses: SurveyResponse[];
  loading: boolean;
  error: string | null;
  formData: SurveyFormData;
  progress: SurveyProgress;
  isSubmitting: boolean;
}
